import { device, richTextHelper } from "@helpers";
import type { IModuleIconRichTextListFields } from "@types-contentful";
import type React from "react";
import styled from "styled-components";
import Icon from "./Icon";

const StyleListWrapper = styled.div`
  margin: 20px 39px;
  display: flex;
  flex-direction: column;
  flex: 1;

  @media (min-width: ${device.tablet}) and (max-width: ${device.laptopM}) {
    margin: 20px 64px;
  }

  @media (min-width: ${device.laptop}) and (max-width: ${device.desktopS}) {
    margin: 20px 166px;
    flex-direction: row;

    > * + * {
      margin-left: 48px;
    }
  }

  @media (min-width: ${device.desktopS}) and (max-width: ${device.desktop}) {
    margin: 40px 241px;
    flex-direction: row;

    > * + * {
      margin-left: 64px;
    }
  }

  @media (min-width: ${device.desktop}) {
    margin: 40px 561px;
    flex-direction: row;

    > * + * {
      margin-left: 128px;
    }
  }
`;

const Centered = styled.div`
  text-align: center;
  flex: 1;
`;

const Text = styled.div`
  margin-top: 20px;
  margin-bottom: 34px;

  @media (min-width: ${device.tablet}) and (max-width: ${device.laptopM}) {
    margin-top: 19px;
  }

  @media (min-width: ${device.laptop}) and (max-width: ${device.desktopS}) {
    margin-top: 36px;
  }

  @media (min-width: ${device.desktopS}) and (max-width: ${device.desktop}) {
    margin-top: 42px;
  }

  @media (min-width: ${device.desktop}) {
    margin-top: 42px;
  }
`;

const iconSizes = {
	iconMobile: 60,
	iconTablet: 60,
	iconLaptop: 60,
	iconDesktop: 80,
	iconDesktopLarge: 80,
};

const IconRichTextListModule: React.FC<IModuleIconRichTextListFields> = ({
	items,
}) => {
	return (
		<StyleListWrapper>
			{items?.map((item, index) => (
				<Centered key={index}>
					<Icon
						iconName={item?.fields?.iconRef}
						iconSizes={iconSizes}
						alt={item?.fields?.iconRef}
					/>
					<Text>
						{richTextHelper(item?.fields?.text && item?.fields?.text)}
					</Text>
				</Centered>
			))}
		</StyleListWrapper>
	);
};

export default IconRichTextListModule;
